import { render, staticRenderFns } from "./ClinicalNotesContainerRightBar.vue?vue&type=template&id=70f42417&"
import script from "./ClinicalNotesContainerRightBar.vue?vue&type=script&lang=js&"
export * from "./ClinicalNotesContainerRightBar.vue?vue&type=script&lang=js&"
import style0 from "./ClinicalNotesContainerRightBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports